import create from './create';
import preview from './preview';
import edit from './edit';
import draft from './draft';
import formParse from './formParse';

export default () => ({ create, preview, edit, draft, formParse });
